import { EpimsBaseEntityDto } from './epim-base.dto';
export class PoliticalPartyDto extends EpimsBaseEntityDto {

    PoliticalPartyId: string;

    PoliticalPartyName: string;

   

}